<template>
    <div class="col-sm-12 col-xl-6 text-start">
        <div class="card">
            <div class="card-header pb-0">
                <h3>Text Color</h3><span>You can Give text color by using txt-* class</span>
            </div>
            <div class="card-body">
                <p class="txt-primary">This is Primary text You can archive this adding <code>.txt-primary</code> class</p>
                <p class="txt-secondary">This is Secondary text You can archive this adding <code>.txt-secondary</code>
                    class</p>
                <p class="txt-success">This is Success text You can archive this adding <code>.txt-success</code> class</p>
                <p class="txt-info">This is Info text You can archive this adding <code>.txt-info</code> class</p>
                <p class="txt-warning">This is Warning text You can archive this adding <code>.txt-warning</code> class</p>
                <p class="txt-danger">This is Danger text You can archive this adding <code>.txt-danger</code> class</p>
                <p class="txt-dark">This is Dark text You can archive this adding <code>.txt-dark</code> class</p>
                <p class="txt-primary">This is Primary text You can archive this adding <code>.txt-primary</code> class</p>
            </div>
        </div>
    </div>
</template>